// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"226":"d8e02846","6124":"432610d1","7044":"b4acc96c"}[chunkId] + ".chunk.css";
};